import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";

const Terms = () => {
  return (
    <div className="min-h-screen bg-[#f1f1f1] flex flex-col">
      <Seo
        title="Terms of Service – CardCombiner"
        description="The terms of service for using CardCombiner.com, the free online image grid and collage maker."
        path="/terms"
      />
      <Navbar />
      <div className="max-w-4xl mx-auto p-4 md:p-8 flex-grow">
        <div className="bg-white p-6 md:p-8 rounded-[16px] md:rounded-[24px] shadow-lg">
          <h1 className="text-3xl md:text-4xl font-bold mb-6 text-[#6B4EE6]">Terms of Service</h1>
          
          <div className="prose max-w-none text-gray-700">
            <p className="mb-4">Last updated: January 26, 2026</p>
            
            <section className="mb-6">
              <h2 className="text-xl md:text-2xl font-semibold mb-3 text-[#6B4EE6]">
                1. Acceptance of Terms
              </h2>
              <p>
                By accessing and using CardCombiner.com ("the Service"), you agree to be bound by these 
                Terms of Service. If you do not agree to these terms, please do not use the Service.
              </p>
            </section>
            
            <section className="mb-6">
              <h2 className="text-xl md:text-2xl font-semibold mb-3 text-[#6B4EE6]">
                2. Description of Service
              </h2>
              <p>
                CardCombiner is a free online tool that allows users to combine multiple images into 
                collages. The Service processes images entirely within your browser—no images are 
                uploaded to or stored on our servers.
              </p>
            </section>
            
            <section className="mb-6">
              <h2 className="text-xl md:text-2xl font-semibold mb-3 text-[#6B4EE6]">
                3. User Responsibilities
              </h2>
              <p>You agree to:</p>
              <ul className="list-disc ml-5 space-y-2 mt-2">
                <li>Use the Service only for lawful purposes</li>
                <li>Not upload or process any illegal, harmful, or copyrighted content without proper authorization</li>
                <li>Not attempt to disrupt, overload, or interfere with the Service</li>
                <li>Not use automated tools to access the Service without our permission</li>
              </ul>
            </section>
            
            <section className="mb-6">
              <h2 className="text-xl md:text-2xl font-semibold mb-3 text-[#6B4EE6]">
                4. Intellectual Property
              </h2>
              <p>
                You retain all rights to the images you process using the Service. CardCombiner does not 
                claim any ownership or rights to your content. The CardCombiner name, logo, and website 
                design are our intellectual property.
              </p>
            </section>
            
            <section className="mb-6">
              <h2 className="text-xl md:text-2xl font-semibold mb-3 text-[#6B4EE6]">
                5. Disclaimer of Warranties
              </h2>
              <p>
                The Service is provided "as is" without warranties of any kind, either express or implied. 
                We do not guarantee that the Service will be uninterrupted, error-free, or meet your 
                specific requirements.
              </p>
            </section>
            
            <section className="mb-6">
              <h2 className="text-xl md:text-2xl font-semibold mb-3 text-[#6B4EE6]">
                6. Limitation of Liability
              </h2>
              <p>
                To the fullest extent permitted by law, CardCombiner and its operators shall not be liable 
                for any indirect, incidental, special, consequential, or punitive damages arising from 
                your use of the Service.
              </p>
            </section>
            
            <section className="mb-6">
              <h2 className="text-xl md:text-2xl font-semibold mb-3 text-[#6B4EE6]">
                7. Modifications to Terms
              </h2>
              <p>
                We reserve the right to modify these Terms of Service at any time. Changes will be 
                effective immediately upon posting to this page. Your continued use of the Service 
                after changes constitutes acceptance of the new terms.
              </p>
            </section>
            
            <section className="mb-6">
              <h2 className="text-xl md:text-2xl font-semibold mb-3 text-[#6B4EE6]">
                8. Contact
              </h2>
              <p>
                If you have questions about these Terms of Service, please contact us at:
              </p>
              <p className="mt-2">
                Email: axel@lumbridgeholding.se
              </p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Terms;
